
// Data Themes are adopted from 'http://publications.europa.eu/resource/authority/data-theme'
export const euDataThemes = [
  { code: "ENER", label: "Energy" },
  { code: "REGI", label: "Regions & Cities" },
  { code: "TECH", label: "Science & Technology" },
  { code: "TRAN", label: "Transport" },
  { code: "SOCI", label: "Population & Society" },
  { code: "AGRI", label: "Agriculture, Fisheries, Forestry & Food" },
  { code: "ECON", label: "Economy & Finance" },
  { code: "JUST", label: "Justice, Legal System & Public Safety" },
  { code: "OP_DATPRO", label: "Open Data Provision" },
  { code: "HEAL", label: "Health" },
  { code: "INTR", label: "International Issues" },
  { code: "ENVI", label: "Environment" },
  { code: "GOVE", label: "Government & Public Sector" },
  { code: "EDUC", label: "Education, Culture & Sport" },
];

// Keys match the backend's ACCESS_RIGHT_URI.
// Adopted from  http://publications.europa.eu/resource/authority/access-right
export const accessRights = [
  { value: "PUBLIC", label: "Public" },
  { value: "RESTRICTED", label: "Restricted" },
  { value: "NON_PUBLIC", label: "Non-Public" },
  { value: "SENSITIVE", label: "Sensitive" },
  { value: "NORMAL", label: "Normal" },
  { value: "OP_DATPRO", label: "OP_DATPRO" },
  { value: "CONFIDENTIAL", label: "Confidential" },
];

export const creatorTypes = ["Official", "Non-Official"];
